import { useEffect, useState } from "react";
import useEmblaCarousel from "embla-carousel-react";
import Autoplay from "embla-carousel-autoplay";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { SmartImage } from "@/components/SmartImage";
import { useGallerySection } from "@/hooks/useGallerySection";

export const AssoPhotoCarousel = () => {
  const { data } = useGallerySection("meninos_brasil_action");
  const [emblaRef, emblaApi] = useEmblaCarousel(
    { loop: true, align: "start", dragFree: false },
    [Autoplay({ delay: 4000, stopOnInteraction: false, stopOnMouseEnter: true })]
  );
  const [selected, setSelected] = useState(0);
  const [snapCount, setSnapCount] = useState(0);

  useEffect(() => {
    if (!emblaApi) return;
    const onSelect = () => setSelected(emblaApi.selectedScrollSnap());
    setSnapCount(emblaApi.scrollSnapList().length);
    emblaApi.on("select", onSelect);
    emblaApi.on("reInit", () => setSnapCount(emblaApi.scrollSnapList().length));
    onSelect();
  }, [emblaApi]);

  const images = data?.images ?? [];
  if (!images.length) {
    return (
      <div className="aspect-[4/3] rounded-2xl border border-background/10 bg-background/5 flex items-center justify-center text-background/50 text-sm">
        Aucune photo pour le moment
      </div>
    );
  }

  return (
    <div className="relative group">
      <div className="overflow-hidden rounded-2xl" ref={emblaRef}>
        <div className="flex">
          {images.map((url, i) => (
            <div key={i} className="relative flex-[0_0_100%] min-w-0">
              <SmartImage
                src={url}
                alt={`Action Meninos do Brasil ${i + 1}`}
                aspectClassName="aspect-[4/3]"
                sizes="(max-width: 1024px) 100vw, 40vw"
                className="object-cover"
              />
            </div>
          ))}
        </div>
      </div>

      {images.length > 1 && (
        <>
          <button
            type="button"
            aria-label="Photo précédente"
            onClick={() => emblaApi?.scrollPrev()}
            className="hidden sm:flex absolute left-3 top-1/2 -translate-y-1/2 w-11 h-11 rounded-full bg-background/80 hover:bg-background text-foreground shadow-lg items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"
          >
            <ChevronLeft className="w-5 h-5" />
          </button>
          <button
            type="button"
            aria-label="Photo suivante"
            onClick={() => emblaApi?.scrollNext()}
            className="hidden sm:flex absolute right-3 top-1/2 -translate-y-1/2 w-11 h-11 rounded-full bg-background/80 hover:bg-background text-foreground shadow-lg items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"
          >
            <ChevronRight className="w-5 h-5" />
          </button>

          <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-1.5">
            {Array.from({ length: snapCount }).map((_, i) => (
              <button
                key={i}
                type="button"
                aria-label={`Aller à la photo ${i + 1}`}
                onClick={() => emblaApi?.scrollTo(i)}
                className={`h-1.5 rounded-full transition-all ${
                  i === selected ? "w-6 bg-roca-orange" : "w-1.5 bg-background/60"
                }`}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default AssoPhotoCarousel;